export default function handleApiError(response) {
    if (response.errors) {
        return response.errors[0].message;
    }
    if (response.error) {
        return response.error.message;
    }
    if (response.message) {
        return response.message
    }
}